import React, { createContext, useContext } from 'react';

export const LabTestHistoryContext = createContext();
export const useLabTestHistoryContext = () => useContext(LabTestHistoryContext);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/state/context.js